import { useEffect } from 'react';
import { useCalculateHoverIntent } from './useCalculateHoverIntent';

/**
 * Custom hook for running callback on user's intended hover
 *
 * @param callback
 * @returns
 */
export const useIntendedHover = <T>(callback?: () => void) => {
    const [isHovering, intentRef] = useCalculateHoverIntent<T>();

    useEffect(() => {
        if (isHovering) {
            callback?.();
        }
    }, [isHovering, callback]);

    return {
        intentRef,
    };
};

export default null;
